import { View } from "extensions/marionette";

import strings from "common/strings";

import template from "./saveReportContent.jst";
import "./saveReportContent.scss";

export const SaveReportContent = View.extend({
    className: "save-report-content",
    template,
    
    events: {
        "change input[type=radio][name=dateRadios]": function(event) {
            this.state.selected_daterange = event.target.value;
        },
        
        "keypress #name": function(e) {
            if (e.which === 13) {
                e.preventDefault();
                this.submitForm();
            }
        },
        
        submit(e) {
            e.preventDefault();
            this.submitForm();
        }
    },
    
    initialize() {
        const { startDate, endDate } = this.getOption("dates");
        
        this.state = {
            violations: [],
            selected_daterange: `${startDate.toISOString()}_${endDate.toISOString()}`
        };
    },
    
    makeNamePlaceholder() {
        const { startDate } = this.getOption("dates");
        return `e.g. ${startDate.format("MMMM YYYY")} ${this.getOption("name").toLowerCase()}`;
    },
    
    makeDateRangeSuggestions() {
        const { startDate, endDate } = this.getOption("dates");
    
        return [
            {
                label: `<b>${startDate.format("MMM D, YYYY")}</b> to <b>${endDate.format("MMM D, YYYY")}`,
                value: `${startDate.toISOString()}_${endDate.toISOString()}`
            },
            {
                label: strings.reports_date_rolling_30_days,
                value: "now-30d_now"
            },
            {
                label: strings.reports_date_current_month,
                value: "now/M_now"
            },
            {
                label: strings.reports_date_last_month,
                value: "now-1M/M_now-1M/M"
            }, {
                label: strings.reports_date_previous_day,
                value: "now-1d/d_now-1d/d"
            }, {
                label: `From ${startDate.format("MMM D, YYYY")} rolling to the current day`,
                value: `${startDate.toISOString()}_now`
            }
        ];
    },
    
    submitForm() {
        this.getOption("parent").getOption("buttons").find(({ role }) => role === "primary").onClick();
    },
    
    templateContext() {
        return {
            name_placeholder: this.makeNamePlaceholder(),
            ranges: this.makeDateRangeSuggestions(),
            state: this.state
        };
    },
    
    getNewReportName() {
        return this.el.querySelector("#name").value.trim();
    },
    
    validate() {
        this.state.violations = [];
        if (!this.getNewReportName()) {
            this.state.violations.push(strings.reports_error_name_required);
        }
        
        if (this.state.violations.length) {
            this.render();
            return false;
        }
        
        return true;
    },
    
    onRender() {
        this.focusNameInput();
    },
    
    focusNameInput() {
        this.el.querySelector("#name").focus();
    },
    
    onShown() {
        this.focusNameInput();
    }
});
